import { render } from "./dashboard-page.vue?vue&type=template&id=1518bbe4&scoped=true"
import script from "./dashboard-page.vue?vue&type=script&lang=js"
export * from "./dashboard-page.vue?vue&type=script&lang=js"

import "./dashboard-page.vue?vue&type=style&index=0&id=1518bbe4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1518bbe4"]])

export default __exports__